/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectCreateUpdateAdminDto } from '../../models/project-create-update-admin-dto';
import { ProjectResponseAdminDto } from '../../models/project-response-admin-dto';

export interface AdminProjectsControllerUpdateProjectV1$Params {
  id: string;
  
    /**
     * Project data with optional image upload (partial update supported)
     */
    body: ProjectCreateUpdateAdminDto
}

export function adminProjectsControllerUpdateProjectV1(http: HttpClient, rootUrl: string, params: AdminProjectsControllerUpdateProjectV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectResponseAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminProjectsControllerUpdateProjectV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectResponseAdminDto>;
    })
  );
}

adminProjectsControllerUpdateProjectV1.PATH = '/v1/admin/projects/{id}';
